import { FormsComponent } from './forms/forms.component';

export const FORMS_COMPONENTS = [FormsComponent];

export * from './forms/forms.component';
